import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Button, Badge, Dropdown, Row, Col } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import axios from 'axios';
import { format } from 'date-fns';
import Approve from '../../../modal/Stock_Management/Weekly_Consumption/Approve';
import MaterialKitchenModal from '../../../modal/Stock_Management/general/MaterialKitchenModal';
import LoadingComponent from '../../../layouts/nav/loading';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const StockIn = () => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const navigate = useNavigate();

    const [selectedDate, setSelectedDate] = useState(format(new Date(), 'yyyy-MM-dd'));
    const [selDateopt, setSelDateopt] = useState(new Date());

    const [datas, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [selectedData, setSelectedData] = useState({});

    // Pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [perPage, setPerPage] = useState(25);

    // Search
    const [searchTerm, setSearchTerm] = useState("");

    // Handle date filter
    const handleStartDateChange = (date) => {
        setSelDateopt(date);
        setSelectedDate(date.format("YYYY-MM-DD"));
        setPage(1);
    };

    // Fetch API
    const fetchData = () => {
        if (!selectedDate) return;

        setLoading(true);

        axios
            .get(`${baseURL}/stock-requests`, {
                params: {
                    menu_date: selectedDate,
                    branch_id,
                    user_id,
                    page,
                    per_page: perPage,
                    search: searchTerm
                }
            })
            .then(res => {
                const result = res.data;

                setData(result.data || []);
                setTotalPages(result.pagination?.last_page || 1);
            })
            .catch(err => console.error(err))
            .finally(() => setLoading(false));
    };

    // Re-fetch when dependencies change
    useEffect(() => {
        fetchData();
    }, [selectedDate, page, perPage, searchTerm]);


    // Approve Modal
    const handleModalToggleApprove = (data) => {
        setSelectedData(data);
        setModalType("Approve");
        setOpen(true);
    };

 const handleRedirectToApproval = (schedule, item) => {
        // navigate("/manage-kitchenConsumption", {
        //     state: { scheduleData: schedule, itemData: item },
        // });
        navigate("/manage-kitchenConsumption", {
    state: { 
        scheduleData: schedule, 
        itemData: item,
        selectedDate: selectedDate   // <-- send selected date
    },
});

    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div>
                    {loading ? (
                    <>
                        <h4 className="text-primary fw-bold mb-1">
                        <Skeleton width={200} height={28} />
                        </h4>
                        <ol className="breadcrumb fs-7 mb-0">
                        <li className="breadcrumb-item"><Skeleton width={100} /></li>
                        <li className="breadcrumb-item"><Skeleton width={60} /></li>
                        <li className="breadcrumb-item active"><Skeleton width={120} /></li>
                        </ol>
                    </>
                    ) : (
                    <>
                        <h4 className="text-primary fw-bold mb-1">Kitchen Material Request</h4>
                        <ol className="breadcrumb fs-7 mb-0">
                        <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Stock Management</li>
                        </ol>
                    </>
                    )}
                   
                </div> 

                {/* Approve Modal */}
                {open && modalType === "Approve" && (
                    <Approve show={open} onClose={() => setOpen(false)} data={selectedData} refresh={fetchData} />
                )}
                
                <div className="d-flex justify-content-between align-items-center mb-2">
                    {loading ? (
                        <>
                            {/* Skeleton for Kitchen Room Button */}
                            <div style={{ width: '140px' }}>
                                <Skeleton height={32} />
                            </div>

                            {/* Skeleton for DatePicker */}
                            <div className="col-lg-6">
                                <div className='datepicker-wrapper d-flex'>
                                    <Skeleton height={32} />
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <Button className="btn btn-success btn-sm" onClick={() => {
                                setModalType("KitchenRoom");
                                setOpen(true);
                            }}>
                                <i className="fa-solid fa-utensils fs-8 me-1"></i> Kitchen Room
                            </Button>

                            <div className="col-lg-6">
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'>
                                        <i className='fa-solid fa-calendar-days fs-4'></i>
                                    </div>
                                    <DatePicker
                                        value={selDateopt}
                                        format="DD-MM-YYYY"
                                        placeholder='Select Date'
                                        onChange={handleStartDateChange}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>

            </div>

            {open && modalType === "KitchenRoom" && (
                <MaterialKitchenModal show={open} onClose={() => setOpen(false)} />
            )}
 
            <div className="d-flex justify-content-between align-items-center mb-3">
                {loading ? (
                    <>
                        {/* Skeleton for "Show entries" dropdown */}
                        <div style={{ width: '120px' }}>
                            <Skeleton height={30} />
                        </div>

                        {/* Skeleton for Search Input */}
                        <div style={{ width: '200px' }}>
                            <Skeleton height={40} />
                        </div>
                    </>
                ) : (
                    <>
                        {/* Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1);
                                }}
                                style={{ fontSize: '0.85rem', height: '30px' }}
                            >
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={125}>125</option>
                            </select>
                        </div>

                        {/* Search Input */}
                        <div>
                            <input
                                type="text"
                                placeholder="Search by Schedule..."
                                className="form-control"
                                style={{ fontSize: '0.85rem', height: '40px' }}
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1);
                                }}
                            />
                        </div>
                    </>
                )}
            </div>


            <Row>
                <Col xl={12}>
                    <div className="table-container">
                        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                         
                            <thead>
                                {loading ? (
                                    <tr>
                                        <th><Skeleton width={80} /></th>
                                        <th><Skeleton width={80} /></th>
                                        <th><Skeleton width={120} /></th>
                                        <th><Skeleton width={120} /></th>
                                        <th className='text-end'><Skeleton width={80} /></th>
                                    </tr>
                                ) : (
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                        <th>Schedule</th>
                                        <th>Food Count</th>
                                        <th>Pending Raw Materials</th>
                                        <th>Total Raw Materials</th>
                                        <th className='text-end'>Status</th>
                                    </tr>
                                )}
                            </thead>

                           <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-3">
                                            <Skeleton height={20} count={1} />
                                        </td>
                                    </tr>
                                ) : datas.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center text-muted py-4">
                                            <i className="fa-solid fa-circle-info me-2"></i>
                                            No Data Found
                                        </td>
                                    </tr>
                                ) : (
                                    datas.map((schedule, sIndex) => (
                                        <tr key={sIndex}>
                                            <td className="text-black">{schedule.schedule_name}</td>
                                            <td className="text-black">{schedule.item_count} No's</td>
                                            <td className="text-black">{schedule.pending_raw_count} No's</td>
                                            <td className="text-black">{schedule.total_raw_material_count} No's</td>

                                            <td align='end'>
                                                {schedule.approval_status === 0 ? (
                                                    <Dropdown>
                                                        <Dropdown.Toggle as="a" className="i-false cursor-pointer">
                                                            <Badge bg="warning" className="py-1 px-2 fs-7">Not Approved</Badge>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item onClick={() => handleRedirectToApproval(schedule)}>
                                                                Approve
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                ) : (
                                                    <span className="cursor-pointer" onClick={() => handleRedirectToApproval(schedule)}>
                                                        <Badge bg="success" className="py-1 px-2 fs-7">Approved</Badge>
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>

                        </table>

                        {/* Pagination Footer */}
                        {/* <div className="d-flex justify-content-between align-items-center mt-3">
                            <span className="text-muted">
                                Page {page} of {totalPages}
                            </span>

                            <nav>
                                <ul className="pagination mb-0" style={{ fontSize: "0.75rem" }}>
                                    <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => setPage(page - 1)}>Prev</button>
                                    </li>

                                    {[...Array(totalPages)].map((_, i) => (
                                        <li key={i} className={`page-item ${page === i + 1 ? "active" : ""}`}>
                                            <button className="page-link" onClick={() => setPage(i + 1)}>
                                                {i + 1}
                                            </button>
                                        </li>
                                    ))}

                                    <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => setPage(page + 1)}>Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div> */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            {loading ? (
                                // Skeleton placeholders while loading
                                <>
                                    <span>
                                        <Skeleton width={80} height={20} />
                                    </span>
                                    <div className="d-flex gap-2">
                                        {Array.from({ length: 5 }).map((_, i) => (
                                            <Skeleton key={i} width={32} height={32} />
                                        ))}
                                    </div>
                                </>
                            ) : (
                                // Actual pagination when data is loaded
                                <>
                                    <span className="text-muted">
                                        Page {page} of {totalPages}
                                    </span>

                                    <nav>
                                        <ul className="pagination mb-0" style={{ fontSize: "0.75rem" }}>
                                            {/* Previous button */}
                                            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                                                <button className="page-link" onClick={() => setPage(page - 1)}>Prev</button>
                                            </li>

                                            {/* Page numbers */}
                                            {[...Array(totalPages)].map((_, i) => (
                                                <li key={i} className={`page-item ${page === i + 1 ? "active" : ""}`}>
                                                    <button className="page-link" onClick={() => setPage(i + 1)}>
                                                        {i + 1}
                                                    </button>
                                                </li>
                                            ))}

                                            {/* Next button */}
                                            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                                                <button className="page-link" onClick={() => setPage(page + 1)}>Next</button>
                                            </li>
                                        </ul>
                                    </nav>
                                </>
                            )}
                        </div>


                    </div>
                </Col>
            </Row>
        </>
    );
};

export default StockIn;
